export var TEXT_ALIGNMENT_VALUES;
(function (TEXT_ALIGNMENT_VALUES) {
    TEXT_ALIGNMENT_VALUES[TEXT_ALIGNMENT_VALUES["LEFT"] = 1] = "LEFT";
    TEXT_ALIGNMENT_VALUES[TEXT_ALIGNMENT_VALUES["CENTER"] = 2] = "CENTER";
    TEXT_ALIGNMENT_VALUES[TEXT_ALIGNMENT_VALUES["RIGHT"] = 3] = "RIGHT";
})(TEXT_ALIGNMENT_VALUES || (TEXT_ALIGNMENT_VALUES = {}));
//# sourceMappingURL=text-alignment-values.js.map